import React from 'react';

const OperationsTable = ({ operations, selectedItems, handleCheckboxChange, formatTime }) => (
  <>
    <h3 className="text-2xl font-extrabold text-white mt-8 mb-4 tracking-wide">
      Operaciones de Hoy
    </h3>

    {operations.length > 0 ? (
      <div className="overflow-x-auto border border-gray-700 rounded-lg shadow-inner mb-6">
        <table className="min-w-full text-sm text-left text-gray-300">
          <thead className="text-xs uppercase bg-gradient-to-r from-gray-800 to-gray-700 text-gray-400">
            <tr>
              <th className="px-5 py-3 text-sm font-semibold tracking-wider">Seleccionar</th>
              <th className="px-5 py-3 text-sm font-semibold tracking-wider">Descripción</th>
              <th className="px-5 py-3 text-sm font-semibold tracking-wider">Comentario</th>
              <th className="px-5 py-3 text-sm font-semibold tracking-wider">Costo</th>
              <th className="px-5 py-3 text-sm font-semibold tracking-wider">Usuario</th>
              <th className="px-5 py-3 text-sm font-semibold tracking-wider">Empleado</th>
              <th className="px-5 py-3 text-sm font-semibold tracking-wider">Hora</th>
            </tr>
          </thead>
          <tbody>
            {operations.map((op, idx) => {
              const isSelected = selectedItems.has(op.operacion_id);
              return (
                <tr
                  key={op.operacion_id}
                  className={`border-b border-gray-700 ${
                    idx % 2 === 0 ? 'bg-gray-900' : 'bg-gray-800'
                  } hover:bg-gray-700 transition-colors`}
                >
                  <td className="px-5 py-3">
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => handleCheckboxChange(op.operacion_id)}
                      className="h-5 w-5 text-indigo-500 bg-gray-700 border-gray-600 rounded focus:ring-indigo-400 focus:ring-2"
                    />
                  </td>
                  <td className="px-5 py-3">{op.descripcion}</td>
                  <td className="px-5 py-3 italic text-gray-400">
                    {op.comentario || 'N/A'}
                  </td>
                  <td className="px-5 py-3 text-green-400 font-medium">${op.costo}</td>
                  <td className="px-5 py-3">{op.usuario_operacion || 'N/A'}</td>
                  <td className="px-5 py-3">{op.empleado_operacion || 'Sin Asignar'}</td>
                  <td className="px-5 py-3">{formatTime(op.hora)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    ) : (
      <p className="text-gray-400 italic mb-6">
        No hay operaciones registradas hoy.
      </p>
    )}
  </>
);

export default OperationsTable;
